<template>
    <div v-if="ready && current" class="md-content">
        <div v-if="mode != 'edit'" class="md-layout ">
            <div v-if="title" class="md-layout md-layout-item md-size-100">
                <span class="md-title">{{title}}&nbsp;</span>
                <md-button class="md-icon-button md-dense md-my-auto ">
                    <md-icon class="md-m-0">info</md-icon><md-tooltip md-direction="right">{{current.description}}</md-tooltip>
                </md-button>
            </div>
            <label v-if="current">{{current.firstName}} {{current.lastName}}</label>
        </div>
        <div v-if="mode == 'edit'" class="md-layout ">
            
            <div class="md-layout-item md-size-100">
                <span v-if="title" class="md-title">{{title}}</span>
            </div>
            <md-field class="md-layout-item md-size-50 md-small-size-100 md-mr-3 ">
                <!--:class="$v.current.firstName|validations"-->
                <label for="txtFirstName">Prénom</label>
                <md-input name="txtFirstName" v-model="current.firstName" type="text" :readonly="isReadOnly" />
            </md-field>
            <md-field class="md-layout-item md-small-size-100 ">
                <!--:class="$v.current.lastName|validations"-->
                <label for="txtLastName">Nom</label>
                <md-input name="txtLastName" v-model="current.lastName" type="text" :readonly="isReadOnly" />
            </md-field>
            <md-field class="md-layout-item md-size-50 md-medium-size-100 md-mr-3 ">
                <label for="txtTitle">Titre</label>
                <md-input name="txtTitle" v-model="current.title" type="text" :readonly="isReadOnly" />
            </md-field>
            <field-culture class="md-layout-item md-small-size-100 " title="Langue usuelle" mode="edit" v-bind:item.sync="current" @md-selected="onCultureSelected" property="lcid" :defaultValue="null" :expand="false" :readonly="isReadOnly" />

            <field-desc class="md-layout md-layout-item md-size-100" v-if="includeDescription != false" title="Description" v-bind:item.sync="current" property="description" :readonly="isReadOnly"  />

            <!-- <md-field class="md-layout-item md-size-50 md-small-size-100 md-mr-3 ">
                <label for="txtIdentityRef">No identification</label>
                <md-input name="txtIdentityRef" v-model="current.identityReference" type="text" :readonly="isReadOnly" />
            </md-field> -->
            <!-- <md-field class="md-layout-item md-small-size-90 ">
                <label for="identityType">Type identification</label>
                <md-select v-model="current.identityTypeId" name="Identities" id="Identities" @md-selected="identityTypeSelected" md-dense>
                    <md-option v-for="(identity, index) in identities" :value="identity.id">{{identity.title}}</md-option>
                </md-select>
            </md-field> -->
        </div>


    </div>
</template>
<style scoped>
    label {
        color: rgba(0, 0, 0, 0.54);
        font-size: 16px;
    }    
</style>
<script>
    //import { required } from 'vuelidate/lib/validators';
    
    import field_culture from '@/components/field-culture.vue';
    import field_desc from '@/components/field-textarea-c.vue';


    export default {
        name: 'contact',
        props: {
            mode: String,
            title: String,
            item: Object,
            includeDescription : Boolean,
            readonly: Boolean,
        },         
        data: () => ({
            current: {},
        }),
        computed: {
            ready: function () {
                let val = false;
                if (this.item) {
                    this.current = this.item;
                    val = true;
                }
                return val;
            },
            isReadOnly: function() {
                return this.readonly;
            },            
        },
        //validations: {
        //    //current: {
        //    //    firstName: { required },
        //    //    lastName: { required },
        //    //}
        //},
        mounted: async function () {

            this.current = this.item;
        },
        methods: {
            onCultureSelected: function (e) {
                this.current.culture = e;
            }
        },
        components: {
            'field-culture' : field_culture,
            'field-desc': field_desc,

        }
    }

</script>